module.exports = __webpack_public_path__ + "img/yq-pic3.b2b7cdef.png";